let str = {
  isString: function (str) {
    return Object.prototype.toString.call(str) === '[object String]';
  },
  isObject: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  },
  // 移除字符串中的空格
  removeBlanks: function (s) {
    try {
      return s.replace(/\s/g, "");
    } catch (e) {
      return s;
    }
  },
}
export default str